<template>
  <v-container fluid>
    <v-alert
      prominent
      type="error"
      class="mx-auto"
      v-if="noTenpoSelected"
      elevation="5"
    >
      <v-row class="text-center" dense>
        <v-col>
            棚卸対象店舗が未選択です。<br>
            店舗を選択してください。
        </v-col>
      </v-row>
      <v-row align="center" dense>
        <v-col>
          <v-btn @click="gotoTenpoList" class="ma-2 btn_text" Rounded large elevation="5" Raised color="white">選択する</v-btn>
        </v-col>
      </v-row>

    </v-alert>
    <v-card
      class="mx-auto"
      outlined
      elevation="5"
      height="350px"
    >
      <v-card-title class="h6">
        <h3>業務メニュー</h3>
      </v-card-title>
      <v-card-text
        class="text-left body-1"
      >
        <strong>選択中店舗：{{ $store.state.tenpoName }}</strong><br>
        <strong>ログインユーザー：{{ $store.state.shainName }}({{ $store.state.shaincd }})</strong><br>
        <br>
        店舗再選択は、<br>
        所属店以外で行う場合に利用ください。
      </v-card-text>
      <v-row>
        <v-col class="d-flex" cols="6" sm="3" xs="3" no-gutters>
          <v-btn @click="gotoInputInventory" class="btn_margin_left btn_text2" 
                Rounded large elevation="5" Raised color="green darken-1">棚卸入力</v-btn>
        </v-col>
        <v-col class="d-flex" cols="6" sm="3" xs="3" no-gutters>
          <v-btn @click="gotoProcessingMaterial" class="btn_margin_left btn_text2" :disabled="noTenpoSelected"
                Rounded large elevation="5" Raised color="green darken-1">加工登録</v-btn>
        </v-col>
        <v-col class="d-flex" cols="6" sm="3" xs="3" no-gutters>
          <v-btn @click="gotoRegistrationProduct" class="btn_margin_left btn_text2" :disabled="noTenpoSelected"
                Rounded large elevation="5" Raised color="green darken-1">廃棄登録</v-btn>
        </v-col>
        <v-col class="d-flex" cols="6" sm="3" xs="3" no-gutters>
          <v-btn @click="gotoTenpoList" class="btn_margin_right btn_text2" 
                Rounded large elevation="5" Raised color="orange darken-4">店舗再選択</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <br>

    <v-card
      class="mx-auto"
      outlined
      elevation="5"
      height="200px"
    >
      <v-card-title class="h6">
        <h3>利用マニュアル</h3>
      </v-card-title>
      <v-card-text
        class="text-left body-1"
      >
        棚卸入力の利用方法については、<br>
        以下のマニュアルを参照ください。<br>
      </v-card-text>

      <v-row>
        <v-col  class="d-flex" cols="12" sm="12" xs="12" no-gutters>
          <v-btn @click="linkToOtherWindow('https://arc-inventory-management-manual.s3.ap-northeast-1.amazonaws.com/%E5%9C%A8%E5%BA%AB%E7%AE%A1%E7%90%86%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_v1.pdf')" class="info btn_margin_left btn_text2" Rounded large elevation="5" Raised>利用マニュアル</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: 'Top',
  components: {
  },
  data() {
    return{
      noTenpoSelected:true,
    }
  },
  created () {
    // 初期表示
    this.checkTenpo();
  },
  methods: {
    checkTenpo() {
      if(this.$store.state.tenpoCd){
        this.noTenpoSelected = false;
      }
    },
    gotoTenpoList(){
      this.$router.push({name: 'TenpoSelect'}).catch(()=>{});
    },
    gotoInputInventory(){
      this.$router.push({name: 'InputInventory'}).catch(()=>{});
    },
    gotoProcessingMaterial(){
      this.$router.push({name: 'ProcessingMaterial'}).catch(()=>{});
    },
    gotoRegistrationProduct(){
      this.$router.push({name: 'RegistrationProduct'}).catch(()=>{});
    },
    linkToOtherWindow (url) {
      window.open(url, '_blank')
    }
  },
}
</script>

<style scoped>
.btn_text {
  color: black;
  font-size: 105%;
  font-weight:bold;
}
.btn_text2 {
  color: white;
  font-size: 105%;
  font-weight:bold;
}
.btn_margin_left {
  margin-left: 10px;
}
.btn_margin_right {
  margin-right: 50px;
}

</style>